/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockDeliveryDetails
 * @description Data access service for managing stock delivery details
 */
angular.module('mercury.modules.stock.deliverydetail')
.factory('StockDeliveryDetails', ["$http", "$q", "$resource", "settings", function($http, $q, $resource, settings) {
  var StockDeliveryDetails = $resource(settings.apiHost + '/r/StockDeliveryDetails/:id', {id: '@id'}, {update: {method: 'PUT'}});

  /**
   * Get a data url for the Company logo
   *
   * @memberof StockDeliveryDetails
   * @param  {String} imageId Image id
   */
  function getLogo(imageId) {
    var result = $q.defer();

    $http({url: settings.apiHost + '/r/Image/' + imageId, method: 'GET', responseType: 'text'})
    .then(function(response) {
      result.resolve('data:image/png;base64,' + response.data);
    }, function(response) {
      result.reject(response);
    });

    return result.promise;
  }

  /**
   * Get the sites delivery details. Includes Company Logo if set
   *
   * @memberof StockDeliveryDetails
   */
  function get() {
    var result = $q.defer();

    StockDeliveryDetails.get()
    .$promise.then(function(response) {
      var details = response;

      if (details.logo) {
        getLogo(details.logo)
        .then(function(logoSrc) {
          details.logosrc = logoSrc;
          result.resolve(details);
        }, function() {
          result.resolve(details);
        });
      } else {
        result.resolve(details);
      }
    }, function(response) {
      result.reject(response);
    });

    return result.promise;
  }

  /**
   * Save delivery details
   *
   * @memberof StockDeliveryDetails
   * @param  {Object} deliveryDetails Delivery details model
   */
  function save(deliveryDetails) {
    var details = angular.copy(deliveryDetails);
    delete details.logosrc;

    return details.$update();
  }

  return {
    get: get,
    getLogo: getLogo,
    save: save
  };
}]);
